$(document).ready(function(){
  $('.slider-info--collection-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    responsive: [
        {
          breakpoint:550,
          settings: {
            slidesToShow: 1,
            arrow:true
          }
        }
      ]
  })
})